import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const MembershipApi = createApi({
  reducerPath: 'MembershipApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['Membership'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({
    getAllMembers: builder.query({
      query: (data) => {
        return {
          url: `membership?page=${data.page}&size=${data.size}&searchid=${data.searchid}&status=${data.status}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Membership'],
    }),

  }),

})

export const { useGetAllMembersQuery } = MembershipApi